module.exports = __webpack_public_path__ + "static/media/cap.fb3c2639.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/Assets/img/cap.svg
// module id = 1084
// module chunks = 0